export default "__VITE_ASSET__DA0UNRk7__"